import { Box } from '@chakra-ui/react';
import React from 'react';

import { useSocketContext } from 'app/socket';
import { Reactions } from 'shared_DEPRECATED/components/Reactions';
import useReactionsData from 'shared_DEPRECATED/components/Reactions/hooks/useReactionsData';
import {
  ReactionActionType,
  ReactionsType,
} from 'shared_DEPRECATED/components/Reactions/types';

import { useUserContext } from 'features/user/context';

export const ChatMessageReactions = ({
  id,
  reactions,
  sendReaction,
  theme,
}: {
  theme: 'light' | 'dark';
  id: string;
  reactions: ReactionsType;
  sendReaction: (
    messageId: string,
    emoji: string,
    type: ReactionActionType
  ) => void;
}) => {
  const { isSocketReady } = useSocketContext();
  const { user } = useUserContext();

  const preparedReactions = useReactionsData(reactions, user.email);

  return (
    <Box opacity={Number(isSocketReady)}>
      <Reactions
        reactions={preparedReactions}
        onEmojiSelect={({
          emoji,
          type,
        }: {
          emoji: string;
          type: ReactionActionType;
        }) => {
          sendReaction(id, emoji, type);
        }}
        theme={theme}
      />
    </Box>
  );
};
